import type { PageProps } from 'gatsby';

import theme from '@klaviyo-mkt/gatsby-components/shared/styles/themes/default';
import UnifiedSearch from '@klaviyo-mkt/gatsby-components/organisms/unified-search';
import algoliaIndexes from '@klaviyo-mkt/gatsby-components/organisms/unified-search/data';


import Layout from '../layout';
const UnifiedSearchTemplate = (pageProps: PageProps) => {
  return (
    <Layout
      {...pageProps}
      bodyClass='body-light-sand'
      heroBackground="lightSand"
      showBreadcrumbs={false}
      templateName="Default"
      theme={theme}
    >
      <UnifiedSearch defaultIndex={algoliaIndexes.marketingSiteIndex} />
    </Layout>
  );
};

export default UnifiedSearchTemplate;
